var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChAdeMo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CHAdeMO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-IOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "#6D6E71",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home/Search-Copy",
    transform: "translate(-170.000000, -397.000000)",
    stroke: "#020303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(36.000000, 373.488281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHAdeMO",
    transform: "translate(135.000000, 24.511719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3713,9.5914 C26.3713,12.6404 23.8993,15.1114 20.8513,15.1114 C17.8023,15.1114 15.3303,12.6404 15.3303,9.5914 C15.3303,6.5424 17.8023,4.0714 20.8513,4.0714 C23.8993,4.0714 26.3713,6.5424 26.3713,9.5914 Z",
    id: "Stroke-1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3001,12.8519 C22.3001,13.6519 21.6511,14.3009 20.8511,14.3009 C20.0511,14.3009 19.4021,13.6519 19.4021,12.8519 C19.4021,12.0519 20.0511,11.4029 20.8511,11.4029 C21.6511,11.4029 22.3001,12.0519 22.3001,12.8519 Z",
    id: "Stroke-3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3001,6.3308 C22.3001,7.1308 21.6511,7.7798 20.8511,7.7798 C20.0511,7.7798 19.4021,7.1308 19.4021,6.3308 C19.4021,5.5308 20.0511,4.8818 20.8511,4.8818 C21.6511,4.8818 22.3001,5.5308 22.3001,6.3308 Z",
    id: "Stroke-5",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1115,8.1422 C24.9115,8.1422 25.5605,8.7912 25.5605,9.5912 C25.5605,10.3912 24.9115,11.0402 24.1115,11.0402 C23.3115,11.0402 22.6625,10.3912 22.6625,9.5912 C22.6625,8.7912 23.3115,8.1422 24.1115,8.1422 Z",
    id: "Stroke-7",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5903,8.1422 C18.3903,8.1422 19.0393,8.7912 19.0393,9.5912 C19.0393,10.3912 18.3903,11.0402 17.5903,11.0402 C16.7903,11.0402 16.1413,10.3912 16.1413,9.5912 C16.1413,8.7912 16.7903,8.1422 17.5903,8.1422 Z",
    id: "Stroke-9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3713,32.1106 C26.3713,35.1596 23.8993,37.6306 20.8513,37.6306 C17.8023,37.6306 15.3303,35.1596 15.3303,32.1106 C15.3303,29.0616 17.8023,26.5906 20.8513,26.5906 C23.8993,26.5906 26.3713,29.0616 26.3713,32.1106 Z",
    id: "Stroke-11",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3001,35.3712 C22.3001,36.1712 21.6511,36.8202 20.8511,36.8202 C20.0511,36.8202 19.4021,36.1712 19.4021,35.3712 C19.4021,34.5712 20.0511,33.9222 20.8511,33.9222 C21.6511,33.9222 22.3001,34.5712 22.3001,35.3712 Z",
    id: "Stroke-13",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3001,28.85 C22.3001,29.65 21.6511,30.299 20.8511,30.299 C20.0511,30.299 19.4021,29.65 19.4021,28.85 C19.4021,28.05 20.0511,27.401 20.8511,27.401 C21.6511,27.401 22.3001,28.05 22.3001,28.85 Z",
    id: "Stroke-15",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1115,30.6615 C24.9115,30.6615 25.5605,31.3105 25.5605,32.1105 C25.5605,32.9105 24.9115,33.5595 24.1115,33.5595 C23.3115,33.5595 22.6625,32.9105 22.6625,32.1105 C22.6625,31.3105 23.3115,30.6615 24.1115,30.6615 Z",
    id: "Stroke-17",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5903,30.6615 C18.3903,30.6615 19.0393,31.3105 19.0393,32.1105 C19.0393,32.9105 18.3903,33.5595 17.5903,33.5595 C16.7903,33.5595 16.1413,32.9105 16.1413,32.1105 C16.1413,31.3105 16.7903,30.6615 17.5903,30.6615 Z",
    id: "Stroke-19",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3746,20.9501 C35.3746,22.9271 33.7716,24.5301 31.7946,24.5301 C29.8186,24.5301 28.2156,22.9271 28.2156,20.9501 C28.2156,18.9731 29.8186,17.3711 31.7946,17.3711 C33.7716,17.3711 35.3746,18.9731 35.3746,20.9501 Z",
    id: "Stroke-21",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4863,20.9501 C13.4863,22.9271 11.8833,24.5301 9.9063,24.5301 C7.9303,24.5301 6.3273,22.9271 6.3273,20.9501 C6.3273,18.9731 7.9303,17.3711 9.9063,17.3711 C11.8833,17.3711 13.4863,18.9731 13.4863,20.9501 Z",
    id: "Stroke-23",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.702,20.851 C41.702,32.365 32.365,41.702 20.851,41.702 C9.337,41.702 0,32.365 0,20.851 C0,14.883 3.995,7.531 3.995,7.531 L4.143,6.066 L10.136,1.737 L11.163,2.356 C11.163,2.356 17.294,0 20.851,0 C24.408,0 30.538,2.356 30.538,2.356 L31.566,1.737 L37.559,6.066 L37.707,7.531 C37.707,7.531 41.702,14.883 41.702,20.851 Z",
    id: "Stroke-25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChAdeMo);
export default __webpack_public_path__ + "static/media/CHAdeMO.04aa2e0eb345cc8b93d9c9384df660b8.svg";
export { ForwardRef as ReactComponent };